import {
  Card,
  Avatar,
  Typography,
  Box,
  Stack,
  Tab,
  Tabs,
  Dialog,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
// MUI Icons
import PhoneIcon from "@mui/icons-material/Phone";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import PersonIcon from "@mui/icons-material/Person";
import PublicIcon from "@mui/icons-material/Public";
import { Cancel, CheckCircle } from "@mui/icons-material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { apiCallFriendList } from "../../../Core/Apicall";
import UserAdminDetails from "./userAdminDetails";
import BoxShimmerList from "../../Common/CommonShimmer/BoxShimmerList";
import PublicUserClickTab from "./UserTab/publicUserClicksTab";
import PublicUserFollowerTab from "./UserTab/publicUserFollowerTab";

export type User = {
  _id: string;
  emailId: string;
  displayEmailId: string;
  phoneNumber: string;
  phoneCountryCode: string;
  socialLoginType: string;
  isDelete: boolean;
  dateOfBirth: string; // ISO string
  fullName: string;
  gender: string;
  profileImagePath: string;
  isApproved: boolean;
  role: number;
  addressType: string;
  city: string;
  zipCode: string;
  country: string;
  stateOrRegion: string;
  myReferralCode: string;
  latitude: number;
  longitude: number;
  addressIsDelete: boolean;
  friendsLoop: number;
  venueLoops: number;
  photoLoops: number;
  themeLoops: number;
  friendsCount: number;
  totalCoins: number;
};

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const TabPanel: React.FC<TabPanelProps> = ({
  children,
  value,
  index,
  ...other
}) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`venue-tabpanel-${index}`}
      aria-labelledby={`venue-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
};

// Dummy user data

export default function PublicUserDetails() {
  const [user, setUser] = useState<User | null>(null);
  const [tabValue, setTabValue] = useState(0);
  const [selectedMediaForPreview, setSelectedMediaForPreview] = useState<
    any | null
  >(null);
  const [tableData, setTableData] = useState<any>();

  const location = useLocation();
  const useData = location.state.user;

  useEffect(() => {
    if (useData) {
      setUser(useData);
      handleApiCall(useData.userId ? useData.userId : useData._id);
    }
  }, [useData]);

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const handleApiCall = async (userId: string) => {
    try {
      const data = { userId };
      const res = await apiCallFriendList(data);
      setTableData(res.data);
    } catch (err) {
    } finally {
    }
  };

  if (!user) return <Typography>Loading...</Typography>;

  return (
    <>
      {tableData?.role === 2 ? (
        <>
          <UserAdminDetails />
        </>
      ) : (
        <Box sx={{ p: 2 }}>
          <Card sx={{ borderRadius: "15px", mb: 3 }}>
            {tableData ? (
              <Box p={2}>
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  mb={3}
                >
                  <Stack direction="row" alignItems="center" spacing={3}>
                    <div
                      style={{ position: "relative", display: "inline-block" }}
                    >
                      <Avatar
                        src={
                          tableData?.profileImagePath || "/default-avatar.png"
                        }
                        sx={{
                          width: 100,
                          height: 100,
                          border: "2px solid #e0e0e0",
                        }}
                        onClick={() =>
                          setSelectedMediaForPreview({
                            type: "Image",
                            url: tableData?.profileImagePath,
                          })
                        }
                      />
                      <div
                        style={{
                          position: "absolute",
                          top: -2,
                          right: -2,
                          backgroundColor: "white",
                          borderRadius: "50%",
                          padding: "2px",
                          boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
                        }}
                      >
                        {tableData?.isApproved ? (
                          <CheckCircle fontSize="small" color="success" />
                        ) : (
                          <Cancel fontSize="small" sx={{ color: "red" }} />
                        )}
                      </div>
                    </div>

                    {/* Name + Email + Role */}
                    <Stack spacing={0.5}>
                      <Typography
                        sx={{
                          color: "black",
                          fontWeight: 600,
                          fontSize: "0.9rem",
                        }}
                      >
                        {tableData?.fullName}
                      </Typography>

                      {/* Email */}
                      <Stack direction="row" alignItems="center" spacing={1}>
                        {/* <EmailIcon fontSize="small" sx={{ color: "grey.600" }} /> */}
                        <Typography
                          sx={{ color: "grey.800", fontSize: "16px" }}
                        >
                          {tableData?.displayEmailId ?? tableData?.emailId}
                        </Typography>
                      </Stack>

                      {/* Role */}
                      <Stack direction="row" alignItems="center" spacing={1}>
                        {/* <BadgeIcon fontSize="small" sx={{ color: "grey.600" }} /> */}
                        <Typography
                          sx={{
                            height: 22,
                            fontSize: "0.9rem",
                            px: 1,
                            // bgcolor: user.role === 1 ? "error.main" : "grey.300",
                            color: user.role === 1 ? "black" : "black",
                            borderRadius: "4px",
                            paddingLeft: "0px",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {"Public Profile"}
                        </Typography>
                      </Stack>
                    </Stack>
                  </Stack>

                  <Box sx={{ ml: "20px", mr: "0px", height: "100%" }}>
                    <Stack
                      direction="row"
                      spacing={6}
                      alignItems="center"
                      style={{ height: "100%" }}
                    >
                      {/* Theme Loops */}
                      <Stack
                        alignItems="center"
                        style={{
                          background: "#ECEFF6",
                          borderRadius: "10px",
                          padding: "10px",
                          marginLeft: "10px",
                          width: 120,
                        }}
                      >
                        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                          {tableData?.followersCount || 0}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          Followers
                        </Typography>
                      </Stack>

                      {/* Photo Loops */}
                      <Stack
                        alignItems="center"
                        style={{
                          background: "#ECEFF6",
                          borderRadius: "10px",
                          padding: "10px",
                          marginLeft: "10px",
                          width: 120,
                        }}
                      >
                        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                          {tableData?.followingCount || 0}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          Following
                        </Typography>
                      </Stack>
                    </Stack>
                  </Box>
                </Stack>

                <Grid
                  container
                  spacing={4}
                  margin={3}
                  marginTop={3}
                  marginBottom={0}
                >
                  {/* Address */}
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <LocationOnIcon fontSize="small" color="action" />
                    <Typography variant="subtitle2">
                      {tableData?.city}, {tableData?.country}
                    </Typography>
                  </Stack>

                  {/* Phone */}
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <PhoneIcon fontSize="small" color="action" />
                    <Typography variant="subtitle2">
                      {tableData?.phoneCountryCode} {tableData?.phoneNumber}
                    </Typography>
                  </Stack>

                  {/* Gender */}
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <PersonIcon fontSize="small" color="action" />
                    <Typography variant="subtitle2">
                      {tableData?.gender}
                    </Typography>
                  </Stack>

                  {/* Date of Birth */}
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <CalendarMonthIcon fontSize="small" color="action" />
                    <Typography variant="subtitle2">
                      {new Date(user.dateOfBirth).toLocaleDateString()}
                    </Typography>
                  </Stack>

                  {/* Social Login */}
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <PublicIcon fontSize="small" color="action" />
                    <Typography variant="subtitle2">
                      {tableData?.socialLoginType}
                    </Typography>
                  </Stack>
                </Grid>
              </Box>
            ) : (
              <BoxShimmerList />
            )}
          </Card>

          {/* Tabs Card */}
          <Card sx={{ borderRadius: "15px" }} variant="outlined">
            <Box>
              <Tabs
                value={tabValue}
                onChange={handleTabChange}
                aria-label="User Tabs"
                sx={{
                  "& .MuiTab-root": {
                    color: "black",
                    fontWeight: "bold",
                    textTransform: "none",
                  },
                  "& .Mui-selected": {
                    color: "white",
                    fontWeight: "bold",
                    backgroundColor: "black",
                    padding: "15px",
                  },
                  "& .MuiTabs-indicator": {
                    backgroundColor: "black",
                  },
                  borderBottom: "2px solid black",
                }}
              >
                <Tab label="Clicks" />
                <Tab label="Friends" />
              </Tabs>

              <TabPanel value={tabValue} index={0}>
                <PublicUserClickTab />
              </TabPanel>
              <TabPanel value={tabValue} index={1}>
                <PublicUserFollowerTab />
              </TabPanel>
            </Box>
          </Card>

          <Dialog
            open={!!selectedMediaForPreview}
            onClose={() => setSelectedMediaForPreview(null)}
          >
            {selectedMediaForPreview?.type === "Image" ? (
              <Avatar
                src={selectedMediaForPreview.url}
                variant="rounded"
                sx={{ width: 300, height: "auto" }}
              />
            ) : selectedMediaForPreview?.type === "Video" ? (
              <video width="300" controls autoPlay>
                <source src={selectedMediaForPreview.url} type="video/mp4" />
              </video>
            ) : selectedMediaForPreview?.type === "Audio" ? (
              <audio controls style={{ width: "300px" }} autoPlay>
                <source src={selectedMediaForPreview.url} type="audio/mpeg" />
              </audio>
            ) : null}
          </Dialog>
        </Box>
      )}
    </>
  );
}
